import { privateApi } from '../private-api';

import type { GetPatientCardsArgs, PatientCardRecord } from './types';

const patientCardApi = privateApi.injectEndpoints({
	endpoints: (build) => ({
		getPatientCards: build.query<PatientCardRecord[], GetPatientCardsArgs>({
			query: (args) => ({
				url: `patient-cards?${new URLSearchParams(args as Record<string, string>).toString()}`,
				method: 'GET',
				credentials: 'include',
			}),
		}),
	}),
});

export const { useGetPatientCardsQuery, useLazyGetPatientCardsQuery } = patientCardApi;
